import { type FC } from 'react';
import { Navigate, Route } from 'react-router';
import { useSuperBundleServiceRoot } from 'src/apis/super-bundle-service/use-super-bundle-service-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { SetOperatorProposal } from 'src/pages/transport/super-bundle/add-information';
import { SupedBundleOfferCreate } from 'src/pages/transport/super-bundle/create';
import { SuperBundleOfferDetails } from 'src/pages/transport/super-bundle/details';
import { OfferOverview } from 'src/pages/transport/super-bundle/page';
import { OfferNotFound } from 'src/pages/transport/super-bundle/utils';

export const SuperBundle: FC = () => {
  const superBundleServiceRoot = useSuperBundleServiceRoot();

  if (!superBundleServiceRoot.response) {
    return <PageSpinner />;
  }

  // Check if there's an active offer before rendering the details component
  const hasActiveOffer = !!superBundleServiceRoot.response.data._links.getOffer;

  return (
    <RootRoutes>
      <Route
        path="/transport/super-bundle"
        element={
          <OfferOverview superBundleServiceRoot={superBundleServiceRoot} />
        }
      />
      <Route
        path="/transport/super-bundle/offers/create"
        element={
          <SupedBundleOfferCreate
            superBundleServiceRoot={superBundleServiceRoot}
          />
        }
      />
      <Route
        path="/transport/super-bundle/offers/:offerId/add-information"
        element={
          <SetOperatorProposal
            superBundleServiceRoot={superBundleServiceRoot}
          />
        }
      />
      <Route
        path="/transport/super-bundle/offers/:offerId"
        element={
          hasActiveOffer ? (
            <SuperBundleOfferDetails
              superBundleServiceRoot={superBundleServiceRoot}
            />
          ) : (
            <OfferNotFound superBundleServiceRoot={superBundleServiceRoot} />
          )
        }
      />
      <Route
        path="/transport/super-bundle/offers"
        element={<Navigate to="/transport/super-bundle" />}
      />
      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
